module.exports = __webpack_public_path__ + "media/images/banner/covid/th-708073b60994e9f37acbe1543b29ed62.jpg";